import { Skeleton } from "atoms/skeleton/Skeleton";
import { CartTopNav } from "modules/cart/CartTopNav/CartTopNav";
export const CartPendingContent = () => {
  return (
    <div className="min-h-screen bg-one">
      <CartTopNav showNavbar />
      <div className="flex flex-col gap-4 p-4 desk:mx-auto desk:max-w-screen-xl desk:px-6 desklg:grid desklg:grid-cols-[minmax(0,1fr)_minmax(0,380px)] desklg:items-start desklg:gap-x-10 desklg:px-8 desk2xl:max-w-screen-2xl">
        <div className="flex flex-col gap-4">
          {[0, 1, 2].map((row) => (
            <Skeleton key={row} className="h-24 w-full rounded-xl" />
          ))}
        </div>
        <div className="flex flex-col gap-4">
          <Skeleton className="h-40 w-full rounded-xl" />
          <Skeleton className="h-12 w-full rounded-full" />
        </div>
      </div>
    </div>
  );
};
